<script>
  import { onMount, onDestroy } from 'svelte';
  import { viewport } from './viewportObserver';
  import * as imgQueue from './imgQueue';
  import cache from './imgCache.js';

  export let visibleOn = 'lg md';
  export let src;
  export let alt = '';
  export let style = undefined;
  export let className = '';

  let imgTag;
  let mounted = false;
  onMount(() => {
    mounted = true;
  });

  let visible = visibleOn.includes(viewport);
  const unsubscribe = viewport.subscribe(v => {
    visible = visibleOn.includes(v);
  });
  onDestroy(unsubscribe);
  
  const smallSrc = src.replace('/img/', '/img-small/');
  let currentSrc = visible ? (cache[smallSrc] || smallSrc) : '';
  let lowResInited = visible;
  let highResIniting = false;
  let highResInited = false;

  $: if (mounted && visible && !lowResInited) {
    currentSrc = (cache[smallSrc] || smallSrc);
    if (!cache[smallSrc]) {
      imgTag.onload = () => { lowResInited = true; };
    } else {
      lowResInited = true;  
    }
  }

  $: if (mounted && visible && lowResInited && !highResIniting && !highResInited) {
    imgQueue.put(src, () => {
      highResInited = true;
      currentSrc = src;
    });
  }
</script>

<img bind:this={imgTag} on:click alt={alt} src={currentSrc} style={style} class={`${className} w-full block max-w-full`} class:smallImage={!highResInited} class:hidden={!visible} />

<style>
  img {
    transition: 0.5s filter ease-in;
  }

  .smallImage {
    filter: blur(0.5rem);
  }

  .hidden {
    display: none;
  }
</style>